/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DevicePlanChangeAction } from './DevicePlanChangeAction';
import {
    DevicePlanChangeActionFromJSON,
    DevicePlanChangeActionFromJSONTyped,
    DevicePlanChangeActionToJSON,
    DevicePlanChangeActionToJSONTyped,
} from './DevicePlanChangeAction';

/**
 * 
 * @export
 * @interface CreateDevicePlanChangeRequest
 */
export interface CreateDevicePlanChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateDevicePlanChangeRequest
     */
    mac_address: string;
    /**
     * 
     * @type {DevicePlanChangeAction}
     * @memberof CreateDevicePlanChangeRequest
     */
    action: DevicePlanChangeAction;
}



/**
 * Check if a given object implements the CreateDevicePlanChangeRequest interface.
 */
export function instanceOfCreateDevicePlanChangeRequest(value: object): value is CreateDevicePlanChangeRequest {
    if (!('mac_address' in value) || value['mac_address'] === undefined) return false;
    if (!('action' in value) || value['action'] === undefined) return false;
    return true;
}

export function CreateDevicePlanChangeRequestFromJSON(json: any): CreateDevicePlanChangeRequest {
    return CreateDevicePlanChangeRequestFromJSONTyped(json, false);
}

export function CreateDevicePlanChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDevicePlanChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mac_address': json['mac_address'],
        'action': DevicePlanChangeActionFromJSON(json['action']),
    };
}

export function CreateDevicePlanChangeRequestToJSON(json: any): CreateDevicePlanChangeRequest {
    return CreateDevicePlanChangeRequestToJSONTyped(json, false);
}

export function CreateDevicePlanChangeRequestToJSONTyped(value?: CreateDevicePlanChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mac_address': value['mac_address'],
        'action': DevicePlanChangeActionToJSON(value['action']),
    };
}

